<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-8 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">Loans and overdrawn bank account balances - {{commonService.headerName}} </h4>
          </div>
          <div class="col-12 col-xxl-4 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <form [formGroup]="LoansandoverdrawnbankSoletraderFormgGroup">
          <div class="row">
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <!--<h5 class="fw-bolder font-size-16">Loans and overdrawn bank account balances</h5>-->
              <div class="mb-3">
                <p class=""></p>
                <p></p>

              </div>
            </div>
            <div class="col-12 text-end">
              <button type="button" class="btn themedefault p-1 ps-2 pe-2 text-lg-end text-start" (click)="AddNew()" [disabled]="disableLoansandoverdrawbanks">+ Add New</button>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-sm-12 col-md-12">
              <div class="row">
                <div class="table-responsive" formArrayName="Wizardrows">
                  <table class="tableheading table dataTable table-bordered border table-striped row-border table-hover pt-10" style="white-space:nowrap !important">
                    <thead>
                      <tr>
                        <th>Item Description</th>
                        <th class="sorting">{{commonService.StartYear}}</th>
                        <th class="sorting" *ngIf="commonService.showControl==true">{{commonService.LastYear}}</th>
                        <th class="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let items of wizardrowslist.controls;let i=index;" [formGroupName]="i">

                        <td>
                          <input class="form-control allowSpecialChars caseSenstive" appNumberdirective type="text" [disabled]="disableLoansandoverdrawbanks" maxlength="100" formControlName="DescriptionShareType" [ngClass]="{ 'is-invalid':(!valid && (wizardrowslist.controls.length > 0) && (wizardrowslist.controls[i].value['DescriptionShareType'] == ''))}" />
                          <span class="text-danger" *ngIf="(!valid && (wizardrowslist.controls.length > 0) && (wizardrowslist.controls[i].value['DescriptionShareType'] == ''))">Item Description is required</span>
                        </td>

                          <td><input class="form-control text-end AccountNumber" maxlength="11" appNumberdirective type="text" formControlName="LoansAndOverdrawnBankSharePremiumSubtotal" (blur)="CalculationsGrid()" /></td>
                          <td *ngIf="commonService.showControl==true" ><input class="form-control text-end AccountNumber" maxlength="11" appNumberdirective type="text" formControlName="LoansAndOverdrawnBankSharePremiumSubtotal_LY" (blur)="CalculationsGrid()" /></td>
                          <!--<td align="center" class="">
                            <a data-toggle="tooltip" data-placement="bottom" title="Delete" class="btn btn-icon   waves-effect waves-light" (click)="DeleteRow(i)">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                            </a>
                          </td>-->
                          <td align="center" class="cursor-pointer">
                            <button class="btn  btn-sm p-1" (click)="DeleteRow(i)" [disabled]="disableLoansandoverdrawbanks" title="Delete"><span class="fa fa-trash-can cantrash text-danger"></span></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div style="text-align:center" *ngIf="!this.wizardrowslist?.length">

                    <b>No records found</b>
                  </div>
                  </div>
                </div>
              </div>
           
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4 pe-0" *ngIf="this.wizardrowslist?.length">
              <div class="row">
                <div [ngClass]="commonService.showControl? 'col-lg-3 col-xxl-4 col-xl-2 col-md-2 col-sm-12 pb-2 text-lg-end text-start w-30':'col-xxl-5 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 w-43-0'"><label class="pt-2">Total</label></div>
                <div [ngClass]="commonService.showControl? 'col-lg-3 col-xxl-3 col-xl-4 col-md-4 col-sm-12 pb-2 w-29-2':'col-xxl-5 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'">
                  <div class="input-group">
                    <div class="input-group-text ">£</div>
                    <input type="text" class="form-control text-end numberonly" maxlength="11" [appTooltip]="showBubbledata" [disabled]="disableLoansandoverdrawbanks" appNumberdirective placeholder="" value="0" formControlName="LoansAndOverdrawnBankSharePremiumSubtotal" />
                  </div>
                </div>
                <div class="" *ngIf="commonService.showControl==true" [ngClass]="commonService.showControl==true? 'w-29-2 ps-3':'col-lg-3 col-xxl-3 col-xl-4 col-md-4 col-sm-12 pb-2'">
                  <div class="input-group">
                    <div class="input-group-text ">£</div>
                    <input type="text" class="form-control text-end numberonly" maxlength="11" [appTooltip]="showBubbledata" [disabled]="disableLoansandoverdrawbanks" appNumberdirective placeholder="" value="0" formControlName="LoansAndOverdrawnBankSharePremiumSubtotal_LY" />
                  </div>
                </div>
                <div class="col-lg-3 col-xxl-1 col-xl-2 col-md-2 text-end">
                </div>
              </div>
            </div>
            <div class="col-xxl-10 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
              <label class="color-black">
                Please enter any additional information in the field below.
              </label>
              <textarea class="form-control txt-area allowSpecialChars" [appTooltip]="showBubbledata" [disabled]="disableLoansandoverdrawbanks" appNumberdirective maxlength="4000" formControlName="LoansAndOverdrawnBankFreeøtextComment" rows="5"></textarea>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4 pe-0">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="On_Back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="On_Next()">Next</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
